export const FEATURES = [
  {
    heading: "Reverse geocoding",
    description: "Click anywhere on our map to obtain location information.",
    id: 1,
    svg: (
      <svg viewBox="0 0 20 20" fill="currentColor" height="1em" width="1em">
        <path d="M10 20S3 10.87 3 7a7 7 0 1114 0c0 3.87-7 13-7 13zm0-11a2 2 0 100-4 2 2 0 000 4z" />
      </svg>
    ),
  },
  {
    heading: "Current weather data",
    description:
      "Obtain weather information such as visibility, humidity, cloudiness and more.",
    id: 2,
    svg: (
      <svg fill="currentColor" viewBox="0 0 16 16" height="1em" width="1em">
        <path d="M4.158 12.025a.5.5 0 01.316.633l-.5 1.5a.5.5 0 01-.948-.316l.5-1.5a.5.5 0 01.632-.317zm6 0a.5.5 0 01.316.633l-.5 1.5a.5.5 0 01-.948-.316l.5-1.5a.5.5 0 01.632-.317zm-3.5 1.5a.5.5 0 01.316.633l-.5 1.5a.5.5 0 01-.948-.316l.5-1.5a.5.5 0 01.632-.317zm6 0a.5.5 0 01.316.633l-.5 1.5a.5.5 0 11-.948-.316l.5-1.5a.5.5 0 01.632-.317zm.747-8.498a5.001 5.001 0 00-9.499-1.004A3.5 3.5 0 103.5 11H13a3 3 0 00.405-5.973z" />
      </svg>
    ),
  },
  {
    heading: "Weather data forecasts",
    description:
      "Receive weather data forecast charts for the next 48 hours and 8 days.",
    id: 3,
    svg: (
      <svg viewBox="0 0 1024 1024" fill="currentColor" height="1em" width="1em">
        <path d="M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 00-11.3 0l-189 189.6a7.87 7.87 0 00-2.3 5.6V720c0 4.4 3.6 8 8 8z" />
      </svg>
    ),
  },
];

export const API_KEY_LOCATION = "41d00e754a8e47ca98268b29fafcd88a";
export const API_KEY_WEATHER = "b69b3c961b1a3f7c747f2c55c6c4bc03";
export const SUPABASE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxnamN0eXdnemFjdnNkYmt2Z3B3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTQ3NDU1MDksImV4cCI6MjAxMDMyMTUwOX0.yJu_ZOZQkF-UmUUIjkR_l98NG7zfDKzF_NlOsXq1i90";
